/* STADTHOLZ FAQ: Akkordeon, Live-Suche, Trefferzahlen in der Themen-Navigation.
   Ohne JavaScript bleiben alle Antworten sichtbar, die Suche bleibt ausgeblendet. */
(function () {
  function norm(s) {
    return (s || '')
      .toLowerCase()
      .replace(/ä/g, 'ae')
      .replace(/ö/g, 'oe')
      .replace(/ü/g, 'ue')
      .replace(/ß/g, 'ss')
      .replace(/\s+/g, ' ');
  }

  function init(root) {
    if (!root || root.dataset.szFaqReady) return;
    root.dataset.szFaqReady = '1';

    var items = Array.prototype.slice.call(root.querySelectorAll('[data-sz-faq-item]'));
    var topics = Array.prototype.slice.call(root.querySelectorAll('[data-sz-faq-topic]'));
    var searchWrap = root.querySelector('[data-sz-faq-search]');
    var input = root.querySelector('[data-sz-faq-input]');
    var hits = root.querySelector('[data-sz-faq-hits]');
    var empty = root.querySelector('[data-sz-faq-empty]');
    var openFirst = root.dataset.openFirst === 'true';

    function setOpen(item, open) {
      item._btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      item._answer.hidden = !open;
      item.classList.toggle('is-open', open);
    }

    items.forEach(function (item, i) {
      item._btn = item.querySelector('.sz-faq__toggle');
      item._answer = item.querySelector('.sz-faq__a');
      item._text = norm(item.textContent);
      item._userOpen = false;
      if (!item._btn || !item._answer) return;
      item._btn.addEventListener('click', function () {
        var open = item._btn.getAttribute('aria-expanded') !== 'true';
        item._userOpen = open;
        setOpen(item, open);
      });
    });

    function openFromHash() {
      var id = '';
      try {
        id = decodeURIComponent(window.location.hash.slice(1));
      } catch (e) {
        id = window.location.hash.slice(1);
      }
      if (!id) return false;
      var found = false;
      items.forEach(function (item) {
        if (item.id === id) {
          item._userOpen = true;
          setOpen(item, true);
          found = true;
        }
      });
      return found;
    }

    // Startzustand: alles zu, erste Frage oder Anker-Ziel offen
    items.forEach(function (item, i) {
      item._userOpen = openFirst && i === 0;
      setOpen(item, item._userOpen);
    });
    if (openFromHash() && openFirst && items[0] && items[0].id !== window.location.hash.slice(1)) {
      items[0]._userOpen = false;
      setOpen(items[0], false);
    }
    window.addEventListener('hashchange', openFromHash);

    // Feedback (optional): nur lokaler Dank, keine Datenübertragung
    Array.prototype.forEach.call(root.querySelectorAll('[data-sz-faq-feedback]'), function (box) {
      box.hidden = false;
      var thanks = box.querySelector('[data-sz-faq-thanks]');
      Array.prototype.forEach.call(box.querySelectorAll('[data-sz-faq-vote]'), function (btn) {
        btn.addEventListener('click', function () {
          Array.prototype.forEach.call(box.querySelectorAll('[data-sz-faq-vote]'), function (b) {
            b.hidden = true;
          });
          if (thanks) thanks.hidden = false;
        });
      });
    });

    if (!searchWrap || !input) return;
    searchWrap.hidden = false;
    var total = items.length;

    function filter() {
      var q = norm(input.value.trim());
      var terms = q ? q.split(' ') : [];
      var count = 0;
      var matches = [];

      items.forEach(function (item) {
        var ok = terms.every(function (t) {
          return item._text.indexOf(t) !== -1;
        });
        item.hidden = !ok;
        if (ok) {
          count++;
          matches.push(item);
        }
      });

      topics.forEach(function (topic) {
        var n = topic.querySelectorAll('[data-sz-faq-item]:not([hidden])').length;
        topic.hidden = n === 0;
        if (!topic.id) return;
        var link = root.querySelector('[data-sz-faq-nav="' + topic.id + '"]');
        if (!link) return;
        var badge = link.querySelector('[data-sz-faq-count]');
        if (badge) badge.textContent = n;
        link.classList.toggle('is-empty', n === 0);
      });

      if (q && count > 0 && count <= 3) {
        matches.forEach(function (item) {
          setOpen(item, true);
        });
      } else {
        items.forEach(function (item) {
          setOpen(item, item._userOpen);
        });
      }

      if (hits) hits.textContent = q ? count + ' Treffer' : total + ' Fragen';
      if (empty) empty.hidden = count !== 0;
    }

    input.addEventListener('input', filter);
    input.addEventListener('search', filter);
  }

  function boot() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-sz-faq]'), init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target.querySelector('[data-sz-faq]'));
  });
})();
